import { render, staticRenderFns } from "./BFlowEdgeProps.vue?vue&type=template&id=33634dce"
import script from "./BFlowEdgeProps.vue?vue&type=script&lang=js"
export * from "./BFlowEdgeProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports